import React from 'react';
import { maskMoney } from '../../masks';

const ProductPricingView = props => {
  const { product, openEdit } = props;
  const hasPricing =
    'paid_price_cents' in product &&
    'unit_price_cents' in product &&
    'yield_grams' in product &&
    'product_unit' in product &&
    'name' in product.product_unit;

  return (
    <div className="cms__section">
      <div className="cms__bar cms__section-head">
        <div className="cms__bar-left">
          <h3 className="h3">Pricing</h3>
        </div>
        <div className="cms__bar-right">
          {renderEditButton(hasPricing, openEdit)}
        </div>
      </div>

      {renderView(hasPricing, product)}
      {renderAddButton(hasPricing, openEdit)}
    </div>
  );
};

const renderView = (hasPricing, product) => {
  if (hasPricing)
    return (
      <div className="cms__section-body">
        <table className="table">
          <thead className="table__thead">
            <tr>
              <th className="p p--bold">Product Price</th>
              <th className="p p--bold">Price per Unit</th>
              <th className="p p--bold">Yield in Grams</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p">{maskMoney(product.paid_price_cents)}</td>
              <td className="p">{`${maskMoney(product.unit_price_cents)}/${
                product.product_unit.name
              }`}</td>
              <td className="p">{product.yield_grams}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
};

const renderEditButton = (hasPricing, openEdit) => {
  if (hasPricing)
    return (
      <a className="a--blue" onClick={openEdit}>
        Edit
      </a>
    );
};

const renderAddButton = (hasPricing, openEdit) => {
  if (!hasPricing)
    return (
      <div className="btn btn--white btn--full-width" onClick={openEdit}>
        + Add Pricing
      </div>
    );
};

export default ProductPricingView;



// WEBPACK FOOTER //
// ./src/components/product/ProductPricingView.js